const styles = (theme) => ({
  listItem: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: 0,
  },
  container: {
    padding: theme.spacing(1.25, 2.5),
    gap: theme.spacing(2.5),

    '&.-withinMiniCart': {
      padding: theme.spacing(1.25, 0),
    },
  },
  priceContainer: {
    padding: theme.spacing(1.25, 2.5),

    '&.-withinMiniCart': {
      padding: theme.spacing(1.25, 0),
      justifyContent: 'space-between',
    },
  },
  divider: {
    margin: theme.spacing(1.25),
    color: theme.color.grey_medium,
    width: '100%',
  },
  productImg: {
    width: 100,
    display: 'flex',
    alignItems: 'flex-start',
    '& img': {
      width: '100%',
      maxHeight: 'fit-content',
    },
    '&.-withinMiniCart': {
      flex: 1,
    },
  },
  details: {
    flexGrow: 1,

    '&.-withinMiniCart': {
      flex: 2,
    },
  },
  name: {
    color: theme.color.black_80,
    maxWidth: 216,
  },
  black: {
    color: theme.color.black_80,
  },
  itemCount: {
    width: 120,
    height: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(1.25, 0),
    marginTop: theme.spacing(2.5),
    border: `1px solid ${theme.color.grey_medium}`,
  },
  counterBtn: {
    background: theme.color.white,
    height: 38,
    fill: theme.color.black_80,
  },
  disabledBtn: {
    fill: theme.color.grey_medium,
  },
  giftIcon: {
    fill: theme.color.teal,
  },
  giftIconLabel: {
    marginTop: theme.spacing(0.5),
    marginLeft: theme.spacing(1.25),
  },
  linkButton: {
    marginTop: theme.spacing(0.5),
    padding: 0,
    fontSize: 14,
  },
  linkButtonWithIcon: {
    padding: 0,
    fontSize: 14,
    marginBottom: theme.spacing(1.25),
  },
  linkButtonLabel: {
    justifyContent: 'flex-start',
  },
  adjustLabel: {
    justifyContent: 'flex-end',
    paddingRight: 5,
  },
  priceBoxLeftCell: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-end',

    '&.-withinMiniCart': {
      width: '50%',
    },
  },
  priceBoxRightCell: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',

    '&.-withinMiniCart': {
      width: '50%',
    },
  },
  priceBoxSingleCell: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  giftOptions: {
    width: '100%',
  },
});

export default styles;
